export default __webpack_public_path__ + "static/media/logo-susa-corto.b89b50c7.png";